export const GET_LIST_EKYC_PENDING_USERS = "GET_LIST_EKYC_PENDING_USERS"
export const GET_LIST_EKYC_PENDING_USERS_ERR = "GET_LIST_EKYC_PENDING_USERS_ERR"